import { ApolloClient, gql } from 'apollo-boost';

export interface OverAllocatedAllocation {
  allocationId: number;
  reportId: number | null;
  npoEmail: string | null;
  amount: string;
  reportEnabled: boolean;
}

export interface OverAllocatedInvitation {
  invitationId: number;
  email: string | null;
  investmentStatus: string | null;
  emailStatus: string | null;
  notificationDt: string | null;
  granteeAccountId: number | null;
  programName: string | null;
}

export interface OverAllocatedInvestmentItem {
  investmentId: number;
  createdAt: string;
  funderName: string | null;
  funderEmail: string | null;
  granteeAccountId: number | null;
  programName: string | null;
  totalInvestment: string;
  totalAllocated: string;
  allocationCount: number;
  isOverAllocated: boolean;
  allocations: OverAllocatedAllocation[];
  invitations: OverAllocatedInvitation[];
}

export interface OverAllocatedInvestmentsResponse {
  overAllocatedInvestments: {
    total: number;
    page: number;
    perPage: number;
    items: OverAllocatedInvestmentItem[];
  };
}

export interface OverAllocatedInvestmentsVariables {
  page: number;
  perPage: number;
  minAllocations?: number | null;
  excludeNameContains?: string[] | null;
  onlyOverAllocated?: boolean;
  onlyEnabledReports?: boolean;
  funderEmailContains?: string | null;
}

const overAllocatedInvestmentsQuery = gql`
  query OverAllocatedInvestments(
    $page: Int
    $perPage: Int
    $minAllocations: Int
    $excludeNameContains: [String]
    $onlyOverAllocated: Boolean
    $onlyEnabledReports: Boolean
    $funderEmailContains: String
  ) {
    overAllocatedInvestments(
      page: $page
      perPage: $perPage
      minAllocations: $minAllocations
      excludeNameContains: $excludeNameContains
      onlyOverAllocated: $onlyOverAllocated
      onlyEnabledReports: $onlyEnabledReports
      funderEmailContains: $funderEmailContains
    ) {
      total
      page
      perPage
      items {
        investmentId
        createdAt
        funderName
        funderEmail
        granteeAccountId
        programName
        totalInvestment
        totalAllocated
        allocationCount
        isOverAllocated
        allocations {
          allocationId
          reportId
          npoEmail
          amount
          reportEnabled
        }
        invitations {
          invitationId
          email
          investmentStatus
          emailStatus
          notificationDt
          granteeAccountId
          programName
        }
      }
    }
  }
`;

export const getOverAllocatedInvestments = (
  client: ApolloClient<object>,
  variables: OverAllocatedInvestmentsVariables,
) =>
  client.query<OverAllocatedInvestmentsResponse>({
    query: overAllocatedInvestmentsQuery,
    variables,
    fetchPolicy: 'network-only',
  });
